import React from "react";
import "./downloadAttach.css";

const DownloadAttach = () => {
  return (
    <div className="transprant_body">
      <div className="download_container shadow">
        <div className="d-flex px-3 align-items-center download_header shadow">
          <span className="col-md-6">Lorem ipsum dolor sit amet.</span>
          <span className="col-md-6">3/5</span>
        </div>
        <div className="row mx-2 my-4 download_img_text">
          <span className="col-6">
            <h6>
              In this COVID-19 era, because relationships are largely digital
              only, they're harder to initiate and harder to grow. Furthermore,
              communications channels are overflowing. And partly because we're
              each trying to manage all this, everyone seems busier. So, to
              break through, marketers must concentrate on being relevant and
              helpful. They need to understand and focus on the buyers' actual
              needs.
            </h6>
            That's why more and more marketers are now turning to new sources of
            behavioral insight-the kind of data that can tell them what active
            buyers truly care about. In this e-book, we'll discuss how changes
            in the interaction landscape are impacting relationship creation and
            how intent data can play a critical role in more successfully
            connecting buyers to the solutions they need. To help you with your
            own efforts, we'll dive into 3 specific ways that intent data at the
            opt-in prospect level supports marketers in driving better ROI via
            Scaled-up ABM principles-ABM 2.0 Evolved ABM buying group strategies
            Operationalized personalization
          </span>
          <img
            className="col-6 download_img"
            alt=""
            src="images/covid_image.jpg"
          />
        </div>
      </div>
    </div>
  );
};

export default DownloadAttach;
